import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import TestSummaryWithMetrics from "./components/TestSummaryView";
import { selectTestMetricsById } from "../store/metricsSlice";
import { selectTestById } from "../store/abtestSlice";

export default function ABTestView() {
    const { testId } = useParams();
    const metrics = useSelector(selectTestMetricsById(testId));
    const test = useSelector(selectTestById(testId));

    const hasMetricsData =
        metrics &&
        typeof metrics === "object" &&
        Object.keys(metrics).length > 0;

    /* ---------------- LOADING ---------------- */
    if (!test) {
        return (
            <div className="min-h-screen w-full flex items-center justify-center bg-slate-50 px-4">
                <p className="text-sm text-slate-500 animate-pulse">
                    Loading test details...
                </p>
            </div>
        );
    }

    /* ---------------- METRICS VIEW ---------------- */
    if (hasMetricsData) {
        return (
            <div className="min-h-screen w-full bg-slate-50 px-3 sm:px-6 lg:px-8 py-4">
                <div className="mx-auto bg-white rounded-xl shadow-sm p-4 sm:p-6">
                    <TestSummaryWithMetrics testId={testId} />
                </div>
            </div>
        );
    }

    /* ---------------- EMPTY STATE ---------------- */
    return (
        <div className="min-h-screen w-full bg-slate-50 px-3 sm:px-6 lg:px-8 py-6">
            <div className="mx-auto bg-white rounded-xl shadow-sm p-6 flex items-center justify-center">
                <p className="text-slate-500">No metrics data available for this test.</p>
            </div>
        </div>
    );
}
